import { TimetableDepartureResponse } from "@/models/api/TimetableDepartureResponse";
import { TimetableDeparture } from "@/models/front/Timetable/TimetableDeparture";

import useApi from "@/composables/useApi";
import { useQuery } from "@tanstack/vue-query";
import { computed, ref } from "vue";

const useTimetableQuery = (routeCode: string) => {
    const { post } = useApi();

    const isLoading = ref(false);

    const fetcher = () => {
        return post<TimetableDepartureResponse[]>("/api/timetable", { routeCode: routeCode }).then((resp) =>
            resp.data.map((departure) => new TimetableDeparture(departure)),
        );
    };

    return {
        ...useQuery({
            queryKey: computed(() => {
                return ["timetable", routeCode];
            }),
            queryFn: fetcher,
            refetchOnWindowFocus: false,
            staleTime: 1000 * 30,
            enabled: computed(() => !!routeCode),
        }),
        isLoading,
        routeCode,
    };
};

export default useTimetableQuery;
